"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M12 3.01H4c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-8c0-.56-.45-1-1-1z"];
//# sourceMappingURL=symbol-square.js.map